import { Container, Heading, Stack } from '@chakra-ui/react'

import BodyText from '~/components/common/BodyText'
import MediumHeading from '~/components/common/MediumHeading'
import { useTranslation } from '~/lib/i18n'

const Terms = () => {
  const { t } = useTranslation('terms')

  return (
    <Container maxW="container.md" pb={{ base: 12, lg: 16 }} pt={{ base: 0, md: '40px' }}>
      <Stack spacing={8} pb={16}>
        <Heading>{t('title')}</Heading>
        <Stack alignItems="flex-start">
          <MediumHeading>{t('introduction.title')}</MediumHeading>
          <BodyText>{t('introduction.body')}</BodyText>
        </Stack>

        <Stack alignItems="flex-start">
          <MediumHeading>{t('elegibility.title')}</MediumHeading>
          <BodyText>{t('elegibility.body')}</BodyText>
        </Stack>

        <Stack alignItems="flex-start">
          <MediumHeading>{t('platformUsage.title')}</MediumHeading>
          <BodyText>{t('platformUsage.body')}</BodyText>
        </Stack>

        <Stack alignItems="flex-start">
          <MediumHeading>{t('promotions.title')}</MediumHeading>
          <BodyText>{t('promotions.body')}</BodyText>
        </Stack>

        <Stack alignItems="flex-start">
          <MediumHeading>{t('risksAndDisclaimers.title')}</MediumHeading>
          <BodyText>{t('risksAndDisclaimers.body')}</BodyText>
        </Stack>

        <Stack alignItems="flex-start">
          <MediumHeading>{t('limitationOfLiability.title')}</MediumHeading>
          <BodyText>{t('limitationOfLiability.body')}</BodyText>
        </Stack>

        <Stack alignItems="flex-start">
          <MediumHeading>{t('indemnification.title')}</MediumHeading>
          <BodyText>{t('indemnification.body')}</BodyText>
        </Stack>

        <Stack alignItems="flex-start">
          <MediumHeading>{t('governingLaw.title')}</MediumHeading>
          <BodyText>{t('governingLaw.body')}</BodyText>
        </Stack>

        <Stack alignItems="flex-start">
          <MediumHeading>{t('amendments.title')}</MediumHeading>
          <BodyText>{t('amendments.body')}</BodyText>
        </Stack>

        <Stack alignItems="flex-start">
          <MediumHeading>{t('severability.title')}</MediumHeading>
          <BodyText>{t('severability.body')}</BodyText>
        </Stack>

        <Stack alignItems="flex-start">
          <MediumHeading>{t('noWaiver.title')}</MediumHeading>
          <BodyText>{t('noWaiver.body')}</BodyText>
        </Stack>

        <Stack alignItems="flex-start">
          <MediumHeading>{t('entireAgreement.title')}</MediumHeading>
          <BodyText>{t('entireAgreement.body')}</BodyText>
        </Stack>

        <Stack alignItems="flex-start">
          <MediumHeading>{t('contactInformation.title')}</MediumHeading>
          <BodyText>{t('contactInformation.body')}</BodyText>
        </Stack>
      </Stack>
    </Container>
  )
}

export default Terms
